import { t } from "ttag";

import { reverse } from "@reactivated";

import { IAddress, IAddressCountry, IAddressState } from "../models/address";
import { fetchJson } from "../utils/ajax";
import { PromiseMutex } from "../utils/mutex";

/**
 * List countries.
 */
export const loadCountries = async (): Promise<IAddressCountry[]> => {
    const mutex = new PromiseMutex<IAddressCountry[]>(
        "address-load-countries",
        true,
    );
    let loading = mutex.getPromise();
    if (!loading) {
        loading = fetchJson(reverse("country-list"));
        mutex.setPromise(loading);
    }
    return loading;
};

/**
 * List states for the given country code
 */
export const loadStates = async (
    countryCode: string,
): Promise<IAddressState[]> => {
    if (!countryCode) {
        throw new Error(
            t`Cannot list shipping methods without a destination state`,
        );
    }

    const mutex = new PromiseMutex<IAddressState[]>(
        `address-load-${countryCode}-states`,
    );
    let loading = mutex.getPromise();
    if (!loading) {
        loading = fetchJson(
            reverse("country-state-list", { country_code: countryCode }),
        );
        mutex.setPromise(loading);
    }
    return loading;
};

/**
 * List addresses saved for the user
 */
export const listUserAddresses = async (): Promise<IAddress[]> => {
    const mutex = new PromiseMutex<IAddress[]>("load-user-addresses");
    let loading = mutex.getPromise();
    if (!loading) {
        loading = fetchJson(reverse("useraddress-list"));
        mutex.setPromise(loading);
    }
    return loading;
};
